import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              深度吃瓜
            </h2>
            <p className="text-sm text-foreground-500">
              精选深度调查与专题报道，吃瓜不止于表面
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="relative w-full aspect-[2/1] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute bottom-4 left-4">
                    <span className="px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-3 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-primary-600 font-medium">
                    <span>阅读全文</span>
                    <i className="ri-arrow-right-line" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}